import { FeatureFlagTypes } from '@/shared/types';

const STORAGE_KEY = 'timepilot-feature-flag-overrides';

export type FlagOverrides = { [key: string]: FeatureFlagTypes };

/**
 * Session-scoped feature-flag overrides from Internal Tools.
 * Cleared when the browser tab/session ends; survives in-app navigation/reloads
 * within the same session.
 */
export function readFlagOverridesFromSession(): FlagOverrides {
  if (typeof sessionStorage === 'undefined') return {};
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    return parsed as FlagOverrides;
  } catch {
    return {};
  }
}

export function writeFlagOverridesToSession(overrides: FlagOverrides): void {
  if (typeof sessionStorage === 'undefined') return;
  try {
    if (Object.keys(overrides).length === 0) {
      sessionStorage.removeItem(STORAGE_KEY);
    } else {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(overrides));
    }
  } catch {
    // sessionStorage may be unavailable (private mode / quota); ignore.
  }
}
